
import { useEffect } from 'react'
import { supabase } from '@/integrations/supabase/client'

interface UseTasksRealtimeProps {
  onUserTasksChange: () => void
  onCustomTasksChange: () => void
  onAdminTasksChange: () => void
  onSchoolTasksChange: () => void
}

export const useTasksRealtime = ({ 
  onUserTasksChange, 
  onCustomTasksChange, 
  onAdminTasksChange, 
  onSchoolTasksChange 
}: UseTasksRealtimeProps) => {
  useEffect(() => {
    // Real-time subscription for user_tasks changes
    const userTasksChannel = supabase
      .channel('user-tasks-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'user_tasks'
        },
        () => {
          console.log('User tasks changed - refreshing data')
          onUserTasksChange()
        }
      )
      .subscribe()

    // Real-time subscription for custom_tasks changes
    const customTasksChannel = supabase
      .channel('custom-tasks-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'custom_tasks'
        },
        () => {
          console.log('Custom tasks changed - refreshing data')
          onCustomTasksChange()
        }
      )
      .subscribe()

    // Real-time subscription for admin_tasks changes
    const adminTasksChannel = supabase
      .channel('admin-tasks-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'admin_tasks'
        },
        () => {
          console.log('Admin tasks changed - refreshing data')
          onAdminTasksChange()
        }
      )
      .subscribe()

    // Real-time subscription for school_tasks changes
    const schoolTasksChannel = supabase
      .channel('school-tasks-changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'school_tasks'
        },
        () => {
          console.log('School tasks changed - refreshing data')
          onSchoolTasksChange()
        }
      )
      .subscribe()

    return () => {
      supabase.removeChannel(userTasksChannel)
      supabase.removeChannel(customTasksChannel)
      supabase.removeChannel(adminTasksChannel)
      supabase.removeChannel(schoolTasksChannel)
    }
  }, [onUserTasksChange, onCustomTasksChange, onAdminTasksChange, onSchoolTasksChange])
}
